import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  flexRender,
} from '@tanstack/react-table';
import { useState } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

// Reusable sortable data table used across Loads, Drivers, Dispatchers,
// and Payments list screens. Pass in `columns` (tanstack column defs)
// and `data` (array of row objects) — sorting is handled automatically.
//
// NOTE: this is a scaffold stub. Fill in per-screen columns when building
// each actual list screen (e.g. Drivers.jsx, Loads.jsx).
function DataTable({ columns, data }) {
  const [sorting, setSorting] = useState([]);

  const table = useReactTable({
    data,
    columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <table style={styles.table}>
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th
                key={header.id}
                onClick={header.column.getToggleSortingHandler()}
                style={styles.th}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  {flexRender(header.column.columnDef.header, header.getContext())}
                  {{ asc: <ChevronUp size={14} />, desc: <ChevronDown size={14} /> }[
                    header.column.getIsSorted()
                  ] ?? null}
                </div>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr key={row.id} style={styles.tr}>
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id} style={styles.td}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const styles = {
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: 'white',
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  },
  th: {
    textAlign: 'left',
    padding: '12px 16px',
    fontSize: 12,
    fontWeight: 700,
    color: '#6b7280',
    backgroundColor: '#f9fafb',
    borderBottom: '1px solid #e5e7eb',
    cursor: 'pointer',
    userSelect: 'none',
  },
  tr: {
    borderBottom: '1px solid #f3f4f6',
  },
  td: {
    padding: '12px 16px',
    fontSize: 13,
    color: '#111827',
  },
};

export default DataTable;
